import { render, staticRenderFns } from "./AgendaSingle.vue?vue&type=template&id=4db09f3e&"
import script from "./AgendaSingle.vue?vue&type=script&lang=js&"
export * from "./AgendaSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports